{
  "carrierLabel": "Transportadora",
  "searchPlaceholder": "Pesquisar por nome",
  "selectAsCarrier": "Selecionar \"{name}\" como transportadora",
  "typeToSearch": "Digite para pesquisar uma empresa"
}
